import React from 'react';

const ListBlock = ({ data, onChange }) => {
  const addItem = () => {
    onChange({ ...data, items: [...data.items, ''] });
  };

  const updateItem = (index, value) => {
    const newItems = [...data.items];
    newItems[index] = value;
    onChange({ ...data, items: newItems });
  };

  const removeItem = (index) => {
    const newItems = data.items.filter((_, i) => i !== index);
    onChange({ ...data, items: newItems });
  };

  return (
    <div className="basic-form">
      <div className="mb-3">
        <label className="form-label">List Type</label>
        <div className="d-flex flex-column flex-md-row gap-3">
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name={`list-type-${data.id}`}
              id={`unordered-${data.id}`}
              checked={!data.ordered}
              onChange={() => onChange({ ...data, ordered: false })}
            />
            <label className="form-check-label" htmlFor={`unordered-${data.id}`}>
              Unordered (bullets)
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name={`list-type-${data.id}`}
              id={`ordered-${data.id}`}
              checked={data.ordered}
              onChange={() => onChange({ ...data, ordered: true })}
            />
            <label className="form-check-label" htmlFor={`ordered-${data.id}`}>
              Ordered (numbers)
            </label>
          </div>
        </div>
      </div>
      
      <label className="form-label">List Items</label>
      {data.items.map((item, index) => (
        <div key={index} className="input-group mb-2">
          <span className="input-group-text">{data.ordered ? `${index + 1}.` : '•'}</span>
          <input
            type="text"
            className="form-control"
            placeholder="List item..."
            value={item}
            onChange={(e) => updateItem(index, e.target.value)}
          />
          <button
            className="btn btn-danger"
            type="button"
            onClick={() => removeItem(index)}
            disabled={data.items.length === 1}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ))}
      <button className="btn btn-primary btn-sm mt-2" type="button" onClick={addItem}>
        <i className="bi bi-plus-circle me-1"></i> Add Item
      </button>
    </div>
  );
};

export default ListBlock;
